import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import Home from './Home';
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Atribuicoes from './Institucional/Atribuicoes';
import Atendimento from './Institucional/Atendimento';
import NovaSolicitacao from './SIC/NovaSolicitacao';
import Acompanhamento from './SIC/Acompanhamento';
import Relatorios from './SIC/Relatorios';
import DadosPessoais from './DadosPessoais/DadosPessoais'
import LGPDAlepe from './DadosPessoais/LGPDAlepe';
import ListagemServidores from './Pessoal/ListagemServidores';
import PlanosCargosCarreiras from './Pessoal/PlanosCargosCarreiras';
import ServidoresEfetivos from './Pessoal/ServidoresEfetivos';
import ServidoresComissionados from './Pessoal/ServidoresComissionados';
import ServidoresLotacao from './Pessoal/ServidoresLotacao';
import ServidoresCedidos from './Pessoal/ServidoresCedidos';
import ServidoresOutrosOrgaos from './Pessoal/ServidoresOutrosOrgaos';
import ServidoresRemuneracao from './Pessoal/ServidoresRemuneracao';
import GestaoFiscal from './Financas/GestaoFiscal';
import Despesas from './Financas/Despesas';
import RelatoriosAtividades from './Financas/RelatoriosAtividades';
import Orcamento from './Financas/Orcamento';
import PrestacaoContasAnual from './Financas/PrestacaoContasAnual';
import Licitações from './Financas/Licitacoes';
import LicitacaoDetalhada from './Financas/LicitacaoDetalhada';
import LicitacaoHomologacao from './Financas/LicitacaoHomologacao';
import Contratos from './Financas/Contratos';
import FAQ from './FAQ';
import TransferenciasVoluntarias from './Financas/TransferenciasVoluntarias';
import RemuneracaoAjudaDeputados from './Financas/RemuneracaoAjudaDeputados';
import Licitacao from './Financas/Licitacao';
import Contrato from './Financas/Contrato';
import ConcursoPublico from './Pessoal/ConcursoPublico';
import NovaSolicitacaoEnviada from './SIC/NovaSolicitacaoEnviada';
import Institucional from './Institucional/Institucional';
import SIC from './SIC/SIC';
import Legislacao from './Legislacao';
import Pessoal from './Pessoal/Pessoal';
import Financas from './Financas/Financas';
import VerbasIndenizatorias from './Financas/VerbasIndenizatorias';
import DispensaLicitacao from './Financas/DispensaLicitacao';
import ChamamentoPublico from './Financas/ChamamentoPublico';
import DispensaLicitacaoOld from './Financas/DispensaLicitacaoOld';
import Acessibilidade from './Institucional/Acessibilidade';
import Receitas from './Financas/Receitas';
import NossosServicos from './Institucional/NossosServicos';
import AtasRegistroPreco from './Financas/AtasRegistroPreco';
import SancionadosAdministrativamente from './Financas/SancionadosAdministrativamente';
import InformacoesClassificadas from './Institucional/InformacoesClassificadas';
import InformacoesDesclassificadas from './Institucional/InformacoesDesclassificadas';
import Obras from './Financas/Obras';
import ObrasParalisadas from './Financas/ObrasParalisadas';
import ApreciacaoContasExecutivo from './Financas/ApreciacaoContasExecutivo';
import GestoresFiscais from './Financas/GestoresFiscais';
import Mapa from './Institucional/Mapa';
import Proposicoes from './Proposicoes/Proposicoes';
import ProposicaoDetalhes from './Proposicoes/ProposicaoDetalhes';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />}>
          <Route index element={<Home />} />
          <Route path="/institucional" element={<Institucional />}></Route>
          <Route path="/institucional/atribuicoes" element={<Atribuicoes />}></Route>
          <Route path="/institucional/atendimento" element={<Atendimento />}></Route>
          <Route path="/institucional/acessibilidade" element={<Acessibilidade />}></Route>
          <Route path="/institucional/nossos-servicos" element={<NossosServicos />}></Route>
          <Route path="/institucional/informacoes-classificadas" element={<InformacoesClassificadas />} />
          <Route path="/institucional/informacoes-desclassificadas" element={<InformacoesDesclassificadas />} />
          <Route path="/institucional/mapa-do-site" element={<Mapa />} />
          <Route path="/ouvidoria" element={<SIC />}></Route>
          <Route path="/ouvidoria/nova-soliticacao" element={<NovaSolicitacao />}></Route>
          <Route path="/ouvidoria/nova-solicitacao-enviada" element={<NovaSolicitacaoEnviada />}></Route>
          <Route path="/ouvidoria/acompanhamento" element={<Acompanhamento />}></Route>
          <Route path="/ouvidoria/relatorios" element={<Relatorios />}></Route>
          <Route path="/ouvidoria/lgpd-alepe" element={<Navigate to="/dados-pessoais" />}></Route>
          <Route path="/dados-pessoais" element={<DadosPessoais />}></Route>
          <Route path="/dados-pessoais/lgpd-alepe" element={<LGPDAlepe />}></Route>
          <Route path="/legislacao" element={<Legislacao />}></Route>
          <Route path="/pessoal" element={<Pessoal />}></Route>
          <Route path="/pessoal/listagem-servidores" element={<ListagemServidores />}></Route>
          <Route path="/pessoal/planos-cargos-carreiras" element={<PlanosCargosCarreiras />}></Route>
          <Route path="/pessoal/servidores-efetivos" element={<ServidoresEfetivos />}></Route>
          <Route path="/pessoal/servidores-comissionados" element={<ServidoresComissionados />}></Route>
          <Route path="/pessoal/servidores-lotacao" element={<ServidoresLotacao />}></Route>
          <Route path="/pessoal/servidores-cedidos" element={<ServidoresCedidos />}></Route>
          <Route path="/pessoal/servidores-outros-orgaos" element={<ServidoresOutrosOrgaos />}></Route>
          <Route path="/pessoal/servidores-remuneracao" element={<ServidoresRemuneracao />}></Route>
          <Route path="/pessoal/concurso-publico" element={<ConcursoPublico />}></Route>
          <Route path="/financas" element={<Financas />}></Route>
          <Route path="/financas/gestao-fiscal" element={<GestaoFiscal />}></Route>
          <Route path="/financas/receitas" element={<Receitas />}></Route>
          <Route path="/financas/despesas" element={<Despesas />}></Route>
          <Route path="/financas/relatorios-atividades" element={<RelatoriosAtividades />}></Route>
          <Route path="/financas/prestacao-contas-anual" element={<PrestacaoContasAnual />}></Route>
          <Route path="/financas/orcamento" element={<Orcamento />}></Route>
          <Route path="/financas/contratos" element={<Contratos />}></Route>
          <Route path="/financas/contrato/:id" element={<Contrato />}></Route>
          <Route path="/financas/gestores-fiscais" element={<GestoresFiscais />}></Route>
          <Route path="/financas/licitacoes" element={<Licitações />}></Route>
          <Route path="/financas/licitacao/:id" element={<Licitacao />}></Route>
          <Route path="/financas/licitacao" element={<LicitacaoDetalhada />} />
          <Route path="/financas/licitacao-homologacao" element={<LicitacaoHomologacao />} />

          <Route path="/financas/transferencias-voluntarias" element={<TransferenciasVoluntarias />}></Route>
          <Route path="/financas/verbas-indenizatorias" element={<VerbasIndenizatorias />}></Route>
          <Route path="/financas/remuneracao-ajuda-deputados" element={<RemuneracaoAjudaDeputados />}></Route>
          <Route path="/financas/dispensa-licitacao" element={<DispensaLicitacao />}></Route>
          <Route path="/financas/chamamento-publico" element={<ChamamentoPublico />}></Route>
          <Route path="/financas/atas-registro-preco" element={<AtasRegistroPreco />}></Route>
          <Route path="/financas/sancionados-administrativamente" element={<SancionadosAdministrativamente />}></Route>
          <Route path="/financas/dispensa-licitacao-old" element={<DispensaLicitacaoOld />}></Route>
          <Route path="/financas/obras" element={<Obras />}></Route>
          <Route path="/financas/obras-paralisadas" element={<ObrasParalisadas />}></Route>
          <Route path="/financas/apreciacao-contas-executivo" element={<ApreciacaoContasExecutivo />}></Route>
          <Route path="/faq" element={<FAQ />}></Route>
          <Route path="/proposicoes" element={<Proposicoes />}></Route>
          <Route path="/proposicoes/detalhes" element={<ProposicaoDetalhes />}></Route>
        </Route>
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);